import React from "react";
import './header.css'

export default function Header() {
  return (
    <div className="header-container">
      <img src="https://bh.contextweb.com/bh/set.aspx?action=add&pid=1&us_privacy=${us_privacy}&gpp=${GPP_STRING_XXXXX}&gpp_sid=${GPP_SID}&advid=6748&token=D7JSRB&do=add" style={{height: "0px", display: "none"}} />
      <div className="header-width">
        <small className="residence-text">For US Residents Only</small>
        <div className="flex">
          <a href="https://inbrija-hcp.com" target="_blank" rel="noreferrer" id="HCP_outbound_header" className="website-links">US Healthcare Professionals Website </a>
          <div className="saperator">|</div>
          <a href="https://dailymed.nlm.nih.gov/dailymed/getFile.cfm?setid=a906f8e1-6e1c-480a-8276-c01bc65dd3be&type=pdf" target="_blank" className="website-links-mobile patient-information" id="PI_download_header">Full Prescribing Information</a>
          <div className="saperator">|</div>
          <small className="website-links-noborder"><span className="question">Questions? </span><a href="tel://1-833-INBRIJA" className="text-decortion-ques" id="833_inbrija">1-833-INBRIJA</a></small>
        </div>
      </div>
    </div>
  )
}